import { useFormContext } from 'react-hook-form';
import { useMemo } from 'preact/compat';
export default function useKeyedWatch(keys) {
    const { watch } = useFormContext();
    return useMemo(() => Object.fromEntries(keys.map((k) => [k, watch(k)])), [keys, watch]);
}
